/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.accountModule', ['angularPayments', 'googleModule', 'lodash', 'mm.foundation',
    'ui.router', 'ui.select', 'bulbApp.authModule', 'bulbApp.badgesModule', 'bulbApp.busyModule', 'bulbApp.configModule',
    'bulbApp.errorModule', 'bulbApp.filtersModule', 'bulbApp.jwplayerModule',
    'bulbApp.modalModule', 'bulbApp.translateModule', 'bulbApp.validationModule'])
.constant('ACCOUNT', {
  PLAN_PREFIX: 'account_settings_plan_',
  CUSTOM_PLAN_PREFIX: 'account_settings_custom_plan_'
})
.run(['$rootScope', 'ACCOUNT', function($rootScope, ACCOUNT) {
  $rootScope.ACCOUNT = ACCOUNT;
}])
.config(['$stateProvider', 'AUTH', function($stateProvider, AUTH) {
    $stateProvider
      .state('account', {
        parent: 'root',
        abstract: true,
        url: '^/b/account',
        resolve: {
        // inject currentUser so the root resolve is completed before this resolve is started.
          account: ['currentUser', 'Restangular', (currentUser, Restangular) => Restangular.one('accounts', currentUser.username).get()],
        },
        views: {
          'content@root': {
            template: '<ui-view></ui-view>',
          },
        },
      })
      .state('account.settings', {
        url: '/settings?errorConnected',
        params: {
          book: { value: false, squash: true },
          errorConnected: { value: '', squash: true },
        },
        resolve: {
          $title: ['$translate', ($translate) => $translate('account_settings_title')],
        },
        template: '<bulb-account-settings></bulb-account-settings>',
        bulbAuth: {
          authorizedRoles: [AUTH.ROLES.REGISTERED_USER],
        },
      })
      .state('account.verifyemail', {
        url: '/verifyemail?token',
        resolve: {
          verifyEmail: ['$window', ($window) => $window.bulbRootModel.verifyEmail],
          $title: ['$translate', ($translate) => $translate('account_verify_email_title')],
        },
        template: '<bulb-account-verify-email></bulb-account-verify-email>',
      })
      .state('planlist', {
        parent: 'root',
        url: '^/b/planlist',
        bulbAuth: {
          authorizedRoles: [AUTH.ROLES.REGISTERED_USER],
        },
        views: {
          'content@root': {
            template: '<bulb-plan-list></bulb-plan-list>',
          },
        },
      });
  }]);
